import React from 'react';
import classnames from 'classnames';
import s from './LegacyListMenu.scss';
export const ListMenu = ({ items, className, containerId, containerRole, itemRole, 'aria-labelledby': ariaLabelledBy })=>/*#__PURE__*/ React.createElement("ul", {
        className: classnames(className, s['list']),
        id: containerId,
        role: containerRole,
        "aria-labelledby": ariaLabelledBy
    }, items.map((item)=>!item.disabled && /*#__PURE__*/ React.createElement("li", {
            key: item.key,
            className: classnames(s['item'], item.className),
            role: itemRole
        }, item.renderElement(item))));
ListMenu.displayName = 'LegacyListMenu';
export default ListMenu;
